
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

interface AppearanceTabProps {
  darkMode: boolean;
  setDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  compactLayout: boolean;
  setCompactLayout: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AppearanceTab = ({
  darkMode,
  setDarkMode,
  compactLayout,
  setCompactLayout
}: AppearanceTabProps) => {
  const { toast } = useToast();
  
  const handleSaveSettings = () => {
    toast({
      title: 'Settings Saved',
      description: 'Your appearance settings have been updated.',
      variant: 'success',
    });
  };
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">Appearance Settings</h2>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Dark Mode</p>
            <p className="text-sm text-gray-500">Switch between light and dark themes</p>
          </div>
          <Switch 
            checked={darkMode} 
            onCheckedChange={setDarkMode} 
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Compact Layout</p>
            <p className="text-sm text-gray-500">Use a more compact UI layout</p>
          </div>
          <Switch 
            checked={compactLayout} 
            onCheckedChange={setCompactLayout} 
          />
        </div>
        
        <Button onClick={handleSaveSettings}>
          Save Appearance Settings
        </Button>
      </div>
    </div>
  );
};
